import locomotiveScroll from "locomotive-scroll"
import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"
import {MorphSVGPlugin} from './js/lib/MorphSVGPlugin.min'
import shapeMorph from './js/modules/shapeMorph'
import {menuToggle} from './js/modules/navbar'
import barba from '@barba/core'
import barbaRouter from '@barba/router'
import {marqueText} from './js/modules/marqueeText'
import { transitionIn, transitionOut } from './js/animations/index'
import generateWorkDetail from './js/context/generateDetail'
import generateTeam from './js/context/generateTeam'
import { getWorks, getTeam, generateWorks } from "./js/context/getData"
import preloaderState from './js/context/preloaderState'
import logo from './images/logo/white.svg'

gsap.registerPlugin(ScrollTrigger);

gsap.registerPlugin(MorphSVGPlugin)
let scroll 

//Mobile detact
const userAgent = navigator.userAgent.toLowerCase();
const bpDesktop = window.matchMedia("(min-width: 1025px)")
const bpTablet = window.matchMedia("(max-width: 1024px)")
const bpMobile = window.matchMedia("(max-width: 576px)")
const md = window.mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
// alert(md())

// alert(md)
function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isTablet() {
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
}

const pagePreloader = document.querySelector('#pagePreloader')

if(!!pagePreloader){
    pagePreloader.innerHTML += `<img src="${logo}" alt="">`
}


function smooth(){
    scroll = new locomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        direction: bpDesktop.matches ? 'horizontal' : 'vertical',
        smooth: true,
        lerp: 0.125,
        reloadOnContextChange: true,
        tablet: {
            direction: bpDesktop.matches ? 'horizontal' : 'vertical',
            smooth: bpDesktop.matches ? true : false
         },
         smartphone: {
             direction: 'vertical',
             smooth: false
        }
    })

    
}

window.addEventListener("resize", debounce(function(e){
    if(bpDesktop.matches){
        scroll.destroy()
        smooth()
    }
    // if(!isMobile() || !isTablet()){
    // }
}))
//Debouncer
function debounce(func){
    var timer;
    return function(event){
      if(timer) clearTimeout(timer);
      timer = setTimeout(func,100,event);
    };
  }

const myRoutes = [
  {
    path: '/index.html',
    name: 'home'
  },
  {
    path: '/about.html',
    name: 'about'
  },
  {
    path: '/contact.html',
    name: 'contact'
  },
  {
    path: '/services.html',
    name: 'services'
  },
  {
    path: '/works/:id',
    name: 'works'
  }
];

barba.use(barbaRouter, {
routes: myRoutes
});

function symbolMorph(){
    const symbols = document.querySelectorAll('.symbol')

    symbols.forEach(symbol =>{
        const star = symbol.querySelector('#star')
        const rect = symbol.querySelector('#rect')
        const shapeAnim = new shapeMorph(star, rect)

        symbol.addEventListener('mouseenter', ()=>{
            shapeAnim.animate()
        })
        symbol.addEventListener('mouseleave', ()=>{
            shapeAnim.animate()
        })
    })
}

function pressEsc(namespace){
    document.onkeydown = function (evt){
        evt = evt || window.event;
        if (evt.keyCode == 27) {
            if(namespace === 'work' || namespace === 'work2'){
                window.history.go(-1)
            }
        }
    }
}

function scrollWheelAnim(container){
    function scrollToStart(){
        scroll.scrollTo(0, 0)
    }

    const spinScrollerElement = !!container.querySelector('.spin-scroller')
    if(spinScrollerElement){
        let lastScroll = 0
        const el = container.querySelector('.spin-scroller')
        const arrow = container.querySelector('.arrow')
        const offset = 100
        scroll.on('scroll', (args) => {
            let sd = window.offsetX || args.scroll.x
            if (sd > lastScroll){
                arrow.style.transform = 'rotate(0deg)'
            } else {
                 arrow.style.transform = 'rotate(180deg)'
             }
            if(Math.ceil(args.scroll.x) > args.limit.x - offset){
                arrow.style.transform = 'rotate(180deg)'
                arrow.parentElement.style.cursor = 'pointer'
                arrow.parentElement.addEventListener('click', scrollToStart)
            }else if(Math.floor(args.scroll.x) < offset){
                arrow.parentElement.style = ''
                arrow.parentElement.removeEventListener('click', scrollToStart)
                arrow.style.transform = 'rotate(0deg)'
            }
            el.style.transform = `rotate(${args.scroll.x * 0.25}deg)`

            lastScroll = sd <= 0 ? 0 : sd;
        });
    }
}

let prevScoll;
let scrollDir;

function prevScrollDetect(namespace){

    scroll.on('scroll', (arg) => {
        if(window.innerWidth > 1024){
            scrollDir = arg.scroll.x
        }else{
            scrollDir = arg.scroll.y
        }
    })
    
    if(namespace === 'home'){ 
        prevScoll = scrollDir
      }
}

barba.hooks.enter((data) => {
    if(data.current.namespace == 'home'){ 
        isHome = true
        prevScoll = scrollDir
    }
    if(data.next.namespace === 'home'){
        getWorks('/static/data.json')
        .then(generateWorks)
        .then(()=>scroll.update())
        .finally(()=> preloaderState())
    }
    if(data.next.namespace === 'about'){
        getTeam('/static/data.json')
        .then(generateTeam)
        .then(()=>scroll.update())
        .finally(()=> preloaderState() )
    }
    if(data.next.namespace !== 'home'){
        window.scrollTo(0, 0)
    }
    
    if(data.next.namespace === 'work' || data.next.namespace === 'work2'){
        window.scrollTo(0, 0)
        scroll.scrollTo(0, {duration: .1})
        scroll.update()
        getWorks('/static/data.json')
        .then((res) => generateWorkDetail(data, res))
        .then(()=>scroll.update())
        .then(()=> mobileAnimation(data.next.container))
        .finally(()=> preloaderState())
    }
})
barba.hooks.beforeEnter((data)=>{
    console.log(data, 'fuck')
    if(data.next.namespace === 'contact' && data.current.container !== null){
        scroll.destroy()
        window.location.reload()
    }
})

barba.hooks.afterEnter((container) => {
    
    if(container.next.namespace == 'home' && container.trigger == 'back'){
        setTimeout(()=>{
            scroll.scrollTo(prevScoll, {duration: .1})
        }, 200)
    }
    
    marqueText(container.next.container)
    window.addEventListener("resize", debounce(function(e){
        marqueText(container.next.container)
    }))

	scroll.update();

    scrollWheelAnim(container.next.container)
    symbolMorph()
});

barba.init({
	debug: true,
	transitions: [
		{
			name: 'general-transition',
			once: (data) => {
				transitionIn(data.next.container);
                symbolMorph()
				smooth()
                prevScrollDetect( data.next.namespace)
                scrollWheelAnim(data.next.container)
                menuToggle(data)
                
                if(data.next.namespace === 'home'){
                    getWorks('/static/data.json')
                        .then(generateWorks)
                        .then(()=>scroll.update())
                        .finally(()=> preloaderState())
                }
                if(data.next.namespace === 'about'){
                    getTeam('/static/data.json')
                        .then(generateTeam)
                        .then(()=>scroll.update())
                        .finally(()=> preloaderState())
                }
                if(data.next.namespace === 'work' || data.next.namespace === 'work2'){
                    pressEsc(data.next.namespace)
                    getWorks('/static/data.json')
                        .then((res) => generateWorkDetail(data, res))
                        .then(()=> scroll.update())
                        .then(()=> mobileAnimation(data.next.container))
                        .finally(()=> preloaderState())
                }
			},
			leave: ({ current }) => transitionOut(current.container),
			enter: ({ next }) => {
                transitionIn(next.container)
                // prevScrollDetect(next.namespace)
			},
			beforeEnter(data) {
                menuToggle(data)
                if(data.current.namespace === 'contact'){
                    smooth()
                    scroll.setScroll(0,0);
                }
                if(data.next.namespace !== 'home'){
                    scroll.setScroll(0, 0)
                    setTimeout(()=>{
                        scroll.update()
                    })
                }
			}
		}
]
});

function mobileAnimation(container){

    let mm = gsap.matchMedia()
    
    mm.add("(max-width: 1024px)", (context) => {
        const isMobileScroll = !!container.querySelector('.scroll-mobile')
        console.log(isMobileScroll);
        if(isMobileScroll){
            const tl = gsap.timeline({
                    scrollTrigger: {
                    trigger: ".scroll-mobile",
                    scrub: true,
                    start: 'top bottom-=10%',
                    end: "bottom top",
                    }
                });
            tl.to('.scroll-mobile-view__grid__scroll-gallery:nth-child(1) img', {y: '-10%'},0)
                .to('.scroll-mobile-view__grid__scroll-gallery:nth-child(2) img', {y: '10%'},0);
        }
        
            const galleryImages = container.querySelectorAll('.plural-works__grid-item')
            
            for(let i = 0; i < galleryImages.length; i++ ){

            const tl2 = gsap.timeline({
                    scrollTrigger: {
                    trigger: galleryImages[i],
                    start: 'top center+=20%',
                    end: "bottom top",
                    }
                });
        
            tl2.fromTo(galleryImages[i], {x: '-100%'}, {x: 0},0)
            }
    });
}